import Vue from 'vue'
import Router from 'vue-router'

const Home = () => import('@/components/Home.vue')
const Login = () => import('@/components/account/AccountLogin.vue')
const Computer = () => import('@/components/Computer.vue')

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/home',
            name: 'Home1',
            component: Home
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/computers/:id',
            name: 'Computers',
            component: Computer
        }
    ]
})